import classNames from 'classnames';
import React from 'react';
import styles from './style.module.scss';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import LayoutRl from './LayoutRl';
import { BackArrowIcon } from 'assets';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';

export default function ViewRoughListing({}) {
    const navigate = useNavigate();
    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start py-4')} style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}>
                <div className="container-fluid" style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    {/* Navigation Header */}
                    <div className="d-flex align-items-center mb-2 ps-2">
                        <button
                            onClick={() => navigate(routeConstant.admin.roughListing.list.path)}
                            className="btn d-flex align-items-center gap-2 border-0 bg-transparent p-0 fw-semibold"
                            style={{ 
                                transition: 'all 0.2s ease', 
                                outline: 'none',
                                color: '#475569',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.color = '#3b82f6'}
                            onMouseLeave={(e) => e.currentTarget.style.color = '#475569'}
                        >
                            <BackArrowIcon style={{ width: '18px', height: '18px', fill: 'currentColor' }} />
                            <span style={{ fontSize: '14px' }}>Back to Rough Listings</span>
                        </button>
                    </div>

                    {/* Detailed View Card */}
                    <div className={classNames(styles.layoutPo)} style={{ border: 'none', padding: 0 }}>
                        <div className={classNames(styles.headingPo)}>
                            <LayoutRl hidePrintButton={true} />
                        </div>
                    </div>
                </div>
            </div>
        </DashboardWrapper>
    );
}
